/**
 * 결과 표의 열 필터 · 값 필터 (2026-10-29 요청).
 *
 * - 열 필터: 열 이름이나 컬럼 주석에 글이 들어간 열만 보인다. 쉼표로 여럿을 적으면 그중 하나라도 맞는 열.
 * - 값 필터: 보이는 열 가운데 하나라도 값(화면에 보이는 글 또는 원래 값)에 글이 들어간 행만 남긴다.
 * 둘 다 대소문자를 가리지 않고, 받아 둔 행 안에서만 거른다(서버에 다시 묻지 않는다).
 */
import { formatCellValue } from './cellFormat';

const norm = (v) => String(v == null ? '' : v).toLowerCase();

/** 열 필터 글을 낱말로 — 쉼표로 나누고 빈 것은 버린다 */
export function columnTerms(query) {
    return String(query || '').split(',').map(x => x.trim().toLowerCase()).filter(Boolean);
}

/** 이 열이 열 필터에 맞는가(이름 또는 주석). 필터가 비면 늘 맞다 */
export function columnMatches(name, comment, query) {
    const terms = columnTerms(query);
    if (terms.length === 0) return true;
    const n = norm(name);
    const c = norm(comment);
    return terms.some(term => n.includes(term) || (c && c.includes(term)));
}

/** 이 칸이 값 필터에 맞는가 — 화면 글(날짜·숫자 형식)과 원래 값 둘 다 본다. NULL 칸은 맞지 않는다 */
export function cellMatches(value, query, gridFormat) {
    const q = String(query || '').trim().toLowerCase();
    if (!q) return true;
    if (value == null) return false;
    const fmt = formatCellValue(value, gridFormat);
    if (fmt.isNull) return false;
    return norm(fmt.text).includes(q) || norm(fmt.raw).includes(q) || norm(value).includes(q);
}
